export const sidebarWidth = 300;
export const navbarHeight = 50;
export const searchModalWidth = 400;
